var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "button",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      staticClass: "xs",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.dialogList.show()
                        },
                      },
                    },
                    [_vm._v("选择逻辑仓")]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.tryCancel } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleConfirm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v("基础信息 ")]
      ),
      _c(
        "el-form",
        { staticStyle: { width: "600px" }, attrs: { "label-width": "130px" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "预留锁定单号" } }, [
                    _c("span", { staticClass: "tips" }, [
                      _vm._v("系统自动生成"),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "仓库编码" } }, [
                    _vm._v(" " + _vm._s(_vm.info.code) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "仓库名称" } }, [
                    _vm._v(" " + _vm._s(_vm.info.name) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remarkText") } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 4 },
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.info.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.info, "remark", $$v)
                          },
                          expression: "info.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "button",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      staticClass: "xs",
                      attrs: { disabled: !_vm.info.code, type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.dialogListGoodsShow()
                        },
                      },
                    },
                    [_vm._v("选择商品")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "xs",
                      attrs: {
                        disabled: _vm.selectedRow.length == 0,
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onDelSelected()
                        },
                      },
                    },
                    [_vm._v("删除商品")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v("商品明细 ")]
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.tableData,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "55",
              align: "center",
              label: "序号",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "categoryName", label: "商品分类" },
          }),
          _c("el-table-column", {
            attrs: { prop: "spuCode", label: "商品编码" },
          }),
          _c("el-table-column", {
            attrs: { prop: "spuName", label: "商品名称" },
          }),
          _c("el-table-column", {
            attrs: { prop: "skuCode", label: "SKU编码" },
          }),
          _c("el-table-column", {
            attrs: { prop: "usableNum", label: "可预留库存" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.row.usableNum || props.row.realityNum || 0
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "planNum", label: "预计预留数量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("BjInput", {
                      attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT },
                      model: {
                        value: props.row.planNum,
                        callback: function ($$v) {
                          _vm.$set(props.row, "planNum", $$v)
                        },
                        expression: "props.row.planNum",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: { config: _vm.$BjDialogListConfig.stockWarehouseLogic() },
        on: { confirm: _vm.onConfirmDialogList },
      }),
      _c("BjDialogList", {
        ref: "dialogListGoods",
        attrs: {
          config: _vm.dialogListConfigGoods,
          multiple: "",
          "row-keys": "skuCode",
        },
        on: { confirm: _vm.onConfirmDialogListGoods },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }